module.exports = __webpack_public_path__ + "public/adminIcons/dlt.png?b7b0462f";